import { useState } from 'react'

export const useHandleZoomImage = () => {
  const [isZooming, setIsZooming] = useState(false)

  const handlePanZoomClick = (e: React.MouseEvent<HTMLDivElement>) => {
    setIsZooming((prevIsZooming) => !prevIsZooming)
    setZoomOrigin(e)
  }

  const handlePanZoomMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isZooming) return
    setZoomOrigin(e)
  }

  const setZoomOrigin = (e: React.MouseEvent<HTMLDivElement>) => {
    const el = e.currentTarget
    const rect = el.getBoundingClientRect()
    el.style.transformOrigin = `${
      ((e.clientX - rect.left) / rect.width) * 100
    }% ${((e.clientY - rect.top) / rect.height) * 100}%`
  }

  return {
    handlePanZoomClick,
    handlePanZoomMove,
    isZooming,
  }
}
